"use client";

import { useEffect, useState } from "react";

type Notice = { message: string; tone: "success" | "error" };
const eventName = "nexo-site-notice";

export function showSiteToast(message: string, tone: Notice["tone"]) {
  const notice: Notice = { message, tone };
  window.dispatchEvent(new CustomEvent<Notice>(eventName, { detail: notice }));
}

export function SiteToast() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const onNotice = (event: Event) => {
      const next = (event as CustomEvent<Notice>).detail;
      setLeaving(false);
      setNotice(next);
    };
    window.addEventListener(eventName, onNotice);
    return () => window.removeEventListener(eventName, onNotice);
  }, []);

  useEffect(() => {
    if (!notice) return;
    const hide = window.setTimeout(() => setLeaving(true), 4_500);
    const clear = window.setTimeout(() => setNotice(null), 4_850);
    return () => { window.clearTimeout(hide); window.clearTimeout(clear); };
  }, [notice]);

  if (!notice) return null;
  return (
    <div className={`site-toast ${notice.tone} ${leaving ? "leaving" : ""}`} role={notice.tone === "error" ? "alert" : "status"}>
      <span aria-hidden="true">{notice.tone === "success" ? "✓" : "!"}</span>
      <p>{notice.message}</p>
      <button type="button" onClick={() => setNotice(null)} aria-label="بستن پیام">×</button>
    </div>
  );
}
